/**
 * The default environment configuration.
 * This configuration is used as the base values in all environments
 */

export interface Config {
  services: {
    api: string;
  };
  isProduction: boolean;
  descope: {
    projectId: string;
    pharmacyPortal: {
      tenant: string;
      flowId: string;
    };
  };
  statsig: {
    sdkKey: string;
    environment: 'development' | 'production' | 'staging';
    api?: string;
    eventLoggingApi?: string;
  };
}

const config: Config = {
  descope: {
    // Set per environment
    pharmacyPortal: {
      flowId: 'sign-in-partner', // Using partner portal flow for testing until pharmacy flows are created
      tenant: '',
    },
    projectId: '',
  },
  isProduction: false,
  services: {
    api: '/api',
  },
  statsig: {
    sdkKey: '',
    environment: 'development',
    api: '/api/ss/v1',
    eventLoggingApi: '/api/ss/v1',
  },
};

export default config;
